import styled, { css } from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import { fontWeightBold, h4Regular } from "../typography/MuiTypography.style";

interface MuiSelectNavigatorWrapperProps {
  $type?: "default" | "primary";
}

const primarySelectStyles = css`
  background-color: ${COLORS.primary_light_blue};
  border-radius: 8px;

  & fieldset {
    border-color: ${COLORS.primary_light_blue};
  }

  &:hover {
    background-color: ${COLORS.primary_dark_blue7};

    fieldset {
      border-color: ${COLORS.primary_dark_blue7};
    }
  }

  &:active {
    background-color: ${COLORS.primary_dark_blue9};
  }

  &:focus-within fieldset,
  &.Mui-focused fieldset,
  &.MuiSelect-outlined.MuiSelect-outlined.Mui-focused fieldset {
    border-color: ${COLORS.primary_light_blue};
    border-width: 1px;
  }

  &.Mui-disabled {
    background-color: ${COLORS.primary_light_blue1};

    .custom-select-content .select-label {
      color: ${COLORS.primary_light_blue5};
    }

    .custom-select-content .custom-expand-icon {
      color: ${COLORS.primary_light_blue5};
    }
  }

  .custom-select-content.open .vertical-divider {
    background-color: ${COLORS.cirrus_white};
  }

  .custom-select-content {
    .select-label {
      color: ${COLORS.cirrus_white};
    }

    .vertical-divider {
      background-color: ${COLORS.cirrus_white};
    }

    .custom-expand-icon {
      color: ${COLORS.cirrus_white};
    }
  }
`;

export const MuiSelectNavigatorWrapper = styled.div<MuiSelectNavigatorWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 5px;

  /* MuiSelectNavigator styles */
  &.mui-select-navigator {
    margin-top: 0;
    width: max-content;

    ${responsive.MOBILE`
      width: 100%;
    `}

    .mui-select {
      width: 285px;
      height: 52px;
      background-color: ${COLORS.cirrus_black2};
      text-align: center;

      & fieldset {
        border-color: ${COLORS.cirrus_black4};
      }
      &:hover fieldset {
        border-color: ${COLORS.primary_light_blue};
      }

      &:focus-within fieldset,
      &.Mui-focused fieldset,
      &.MuiSelect-outlined.MuiSelect-outlined.Mui-focused fieldset {
        border-color: ${COLORS.primary_light_blue};
        border-width: 1px;
      }

      .custom-select-content {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 8px;
        box-sizing: border-box;
        justify-content: space-evenly;

        .select-label {
          color: ${COLORS.primary_light_blue};
          width: 180px;
          margin: 16px;
          line-height: 20px;
          ${h4Regular}
          ${fontWeightBold}
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          ${responsive.MOBILE`
            flex: 1;
          `}
        }

        .vertical-divider {
          width: 1px;
          height: 100%;
          background-color: ${COLORS.cirrus_black4};
          margin: 0 8px;
        }

        .custom-expand-icon {
          color: ${COLORS.primary_light_blue};
          width: 32px;
          height: 27px;
          margin: 5px;
          transform: rotate(0deg);
        }

        .custom-expand-icon.rotated {
          transform: rotate(180deg);
        }
      }

      .custom-select-content.open .vertical-divider {
        background-color: ${COLORS.primary_light_blue};
      }

      ${({ $type }) => $type === "primary" && primarySelectStyles}
    }

    .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {
      width: 100%;
      padding: 0px;
      height: 100%;
    }
  }

  .mui-label {
    color: ${COLORS.cirrus_black10};
    line-height: 20px;
    margin-bottom: 8px;
    &.disabled {
      color: ${COLORS.cirrus_black5};
    }
  }

  .asterisk {
    color: ${COLORS.cirrus_red};
  }
  .mui-select {
    border-color: ${COLORS.cirrus_black4};
    border-radius: 8px;
    background-color: ${COLORS.cirrus_black1};
    color: ${COLORS.cirrus_black};
    & fieldset {
      border-color: ${COLORS.cirrus_black4};
    }
    &:hover fieldset {
      border-color: ${COLORS.cirrus_black};
    }

    &:focus-within fieldset,
    &.Mui-focused fieldset,
    &.MuiSelect-outlined.MuiSelect-outlined.Mui-focused fieldset {
      border-color: ${COLORS.cirrus_black};
      border-width: 1px;
    }

    &.Mui-error {
      fieldset {
        border: 2px solid ${COLORS.cirrus_red};
      }
    }
    .MuiSelect-iconOutlined {
      width: 32px;
      height: 27px;
      color: ${COLORS.primary_light_blue};
      margin-right: 4px;
    }
  }

  .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {
    box-sizing: border-box;
    padding: 15px 16px;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
    width: calc(100% - 20px);
  }
`;
